import React from 'react';
import PropTypes from 'prop-types';
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import SoftBox from "../../../components/SoftBox";
import SoftTypography from "../../../components/SoftTypography";
import {Chip, Grid, Typography} from "@mui/material";

function CompanyAdminInfo({companyAdmin}) {
    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        return new Date(dateString).toLocaleDateString();
    };

    const formatDateTime = (dateString) => {
        if (!dateString) return 'N/A';
        return new Date(dateString).toLocaleString();
    };

    const getStatusColor = (status) => {
        switch (status) {
            case 'ACTIVE':
                return 'success';
            case 'INACTIVE':
                return 'error';
            case 'PENDING':
                return 'warning';
            default:
                return 'default';
        }
    };

    const getGenderDisplayName = (gender) => {
        switch (gender) {
            case 'MALE':
                return 'Male';
            case 'FEMALE':
                return 'Female';
            case 'OTHER':
                return 'Other';
            default:
                return 'N/A';
        }
    };

    const getIdTypeDisplayName = (idType) => {
        switch (idType) {
            case 'MYKAD':
                return 'MyKad';
            case 'PASSPORT':
                return 'Passport';
            default:
                return 'N/A';
        }
    };

    const getCompanyDisplayName = (company) => {
        if (!company) return 'N/A';
        return company.companyName || company.name || 'N/A';
    };

    return (
        <Card>
            <CardContent>
                <Typography variant="h6" gutterBottom>
                    Profile Information
                </Typography>

                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <SoftBox mb={2}>
                            <SoftTypography variant="button" fontWeight="bold" color="text">
                                Email Address
                            </SoftTypography>
                            <SoftTypography variant="body2" color="text">
                                {companyAdmin.email || 'N/A'}
                            </SoftTypography>
                        </SoftBox>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <SoftBox mb={2}>
                            <SoftTypography variant="button" fontWeight="bold" color="text">
                                Phone Number
                            </SoftTypography>
                            <SoftTypography variant="body2" color="text">
                                {companyAdmin.phoneNumber || 'N/A'}
                            </SoftTypography>
                        </SoftBox>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <SoftBox mb={2}>
                            <SoftTypography variant="button" fontWeight="bold" color="text">
                                Gender
                            </SoftTypography>
                            <SoftTypography variant="body2" color="text">
                                {getGenderDisplayName(companyAdmin.gender)}
                            </SoftTypography>
                        </SoftBox>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <SoftBox mb={2}>
                            <SoftTypography variant="button" fontWeight="bold" color="text">
                                Birth Date
                            </SoftTypography>
                            <SoftTypography variant="body2" color="text">
                                {formatDate(companyAdmin.birthDate)}
                            </SoftTypography>
                        </SoftBox>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <SoftBox mb={2}>
                            <SoftTypography variant="button" fontWeight="bold" color="text">
                                ID Type
                            </SoftTypography>
                            <SoftTypography variant="body2" color="text">
                                {getIdTypeDisplayName(companyAdmin.idType)}
                            </SoftTypography>
                        </SoftBox>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <SoftBox mb={2}>
                            <SoftTypography variant="button" fontWeight="bold" color="text">
                                ID Number
                            </SoftTypography>
                            <SoftTypography variant="body2" color="text">
                                {companyAdmin.idNumber || 'N/A'}
                            </SoftTypography>
                        </SoftBox>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <SoftBox mb={2}>
                            <SoftTypography variant="button" fontWeight="bold" color="text">
                                Company
                            </SoftTypography>
                            <SoftTypography variant="body2" color="text">
                                {getCompanyDisplayName(companyAdmin.company) || companyAdmin.companyName || 'N/A'}
                            </SoftTypography>
                        </SoftBox>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <SoftBox mb={2}>
                            <SoftTypography variant="button" fontWeight="bold" color="text">
                                User Role
                            </SoftTypography>
                            <Chip
                                label={companyAdmin.userRole || 'COMPANY_ADMIN'}
                                color="primary"
                                size="small"
                                variant="outlined"
                            />
                        </SoftBox>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <SoftBox mb={2}>
                            <SoftTypography variant="button" fontWeight="bold" color="text">
                                Status
                            </SoftTypography>
                            <Chip
                                label={companyAdmin.status || 'ACTIVE'}
                                color={getStatusColor(companyAdmin.status)}
                                size="small"
                                variant="outlined"
                            />
                        </SoftBox>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <SoftBox mb={2}>
                            <SoftTypography variant="button" fontWeight="bold" color="text">
                                Last Login
                            </SoftTypography>
                            <SoftTypography variant="body2" color="text">
                                {formatDateTime(companyAdmin.lastLogin)}
                            </SoftTypography>
                        </SoftBox>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <SoftBox mb={2}>
                            <SoftTypography variant="button" fontWeight="bold" color="text">
                                Username
                            </SoftTypography>
                            <SoftTypography variant="body2" color="text">
                                {companyAdmin.username || 'N/A'}
                            </SoftTypography>
                        </SoftBox>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <SoftBox mb={2}>
                            <SoftTypography variant="button" fontWeight="bold" color="text">
                                Created At
                            </SoftTypography>
                            <SoftTypography variant="body2" color="text">
                                {formatDateTime(companyAdmin.createdAt)}
                            </SoftTypography>
                        </SoftBox>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <SoftBox mb={2}>
                            <SoftTypography variant="button" fontWeight="bold" color="text">
                                Updated At
                            </SoftTypography>
                            <SoftTypography variant="body2" color="text">
                                {formatDateTime(companyAdmin.updatedAt)}
                            </SoftTypography>
                        </SoftBox>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
}

CompanyAdminInfo.propTypes = {
    companyAdmin: PropTypes.shape({
        email: PropTypes.string,
        phoneNumber: PropTypes.string,
        gender: PropTypes.string,
        birthDate: PropTypes.string,
        idType: PropTypes.string,
        idNumber: PropTypes.string,
        company: PropTypes.object,
        companyName: PropTypes.string,
        userRole: PropTypes.string,
        status: PropTypes.string,
        lastLogin: PropTypes.string,
        username: PropTypes.string,
        createdAt: PropTypes.string,
        updatedAt: PropTypes.string,
    }).isRequired,
};

export default CompanyAdminInfo;

